import { NumberService } from '../shared/number.service';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../shared/number.service";
const epsilon = 0.001;
const zoomRate = 0.03;
export class CameraService {
    constructor(numberService) {
        this.numberService = numberService;
        this.rotation = { vx: 0, vy: 0 };
        this.pan = { x: 0, y: 0, z: 0 };
        this.zoom = 0;
    }
    getEye() {
        return Human.renderer.camera.eye;
    }
    setEye(eye) {
        Human.renderer.camera.setLookAt({
            eye
        });
    }
    getCamera() {
        return Human.renderer.camera.getLookAt();
    }
    setCamera(camera) {
        return Human.renderer.camera.setLookAt(camera);
    }
    getCameraZoom() {
        return Human.renderer.camera.getZoom();
    }
    captureCamera() {
        return {
            lookAt: Human.renderer.camera.getLookAt(),
            zoom: Human.renderer.camera.getZoom()
        };
    }
    resetCamera() {
        return new Observable((observer) => {
            Human.init.resetCamera(() => {
                observer.next();
                observer.complete();
            });
        });
    }
    getDirection(hit) {
        const camera = this.getEye();
        const direction = vec3.create();
        direction[0] = camera.x - hit.worldPos[0];
        direction[1] = camera.y - hit.worldPos[1];
        direction[2] = camera.z - hit.worldPos[2];
        vec3.normalize(direction, direction);
        return direction;
    }
    rotateCameraStatic(x, y) {
        Human.renderer.camera.rotateX(x);
        Human.renderer.camera.rotateY(y);
    }
    panCameraStatic(x, y, z) {
        Human.renderer.camera.pan({ x, y, z });
    }
    setHumanZoom(delta) {
        Human.renderer.camera.zoom(delta);
    }
    setHumanZoomFactor(zoomFactor) {
        Human.renderer.camera.setZoom(zoomFactor);
    }
    setCameraRotation(velocityX, velocityY) {
        this.rotation.vx = velocityY;
        this.rotation.vy = -velocityX;
    }
    setCameraPan(velocityX, velocityY) {
        this.pan.x = velocityX;
        this.pan.y = velocityY;
    }
    setCameraZoom(deltaY) {
        this.zoom = deltaY * zoomRate;
    }
    tickCameraRotation() {
        this.rotation.vx = this.checkEpsilon(this.rotation.vx);
        this.rotation.vy = this.checkEpsilon(this.rotation.vy);
        return this.rotation;
    }
    tickCameraPan() {
        this.pan.x = this.checkEpsilon(this.pan.x);
        this.pan.y = this.checkEpsilon(this.pan.y);
        this.pan.z = this.checkEpsilon(this.pan.z);
        return this.pan;
    }
    tickCameraZoom() {
        this.zoom = this.checkEpsilon(this.zoom);
        return this.zoom;
    }
    /**
     * Returns if the cameras are equivalent.
     */
    compareCameras(camera1, camera2) {
        return this.compareXYZ(camera1.eye, camera2.eye)
            && this.compareXYZ(camera1.look, camera2.look)
            && this.compareXYZ(camera1.up, camera2.up);
    }
    /**
     * Returns if the XYZ coordinates are equal.
     */
    compareXYZ(model1, model2) {
        return model1.x === model2.x
            && model1.y === model2.y
            && model1.z === model2.z;
    }
    /**
     * Rounds the camera to the specified precision.
     */
    roundCamera(camera, precision) {
        const { eye, look, up } = camera;
        return {
            eye: this.numberService.roundModel(eye, precision),
            look: this.numberService.roundModel(look, precision),
            up: this.numberService.roundModel(up, precision)
        };
    }
    checkEpsilon(value) {
        return (Math.abs(value) < epsilon) ? 0 : value;
    }
}
CameraService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CameraService_Factory() { return new CameraService(i0.ɵɵinject(i1.NumberService)); }, token: CameraService, providedIn: "root" });
